/**
 * 🟥 P26.41 · WORKSPACE API REAL — `window.DamyxWorkspaceAPI`
 *
 * Los nombres son CONTRACTUALES (regla 8 del guardrail): si se renombra uno,
 * el guardrail se rompe. El Workspace registra las implementaciones reales al
 * montarse; acá sólo vive la superficie pública + el registro.
 */

export const WORKSPACE_API_NAMES = [
  'getActiveProjectId',
  'getActiveItem',
  'openProject',
  'setActiveItem',
  'compile',
  'stopCompile',
  'showPreview',
  'saveFile',
  'createModule',
  'createDocument',
  'deleteItem',
  'restoreItem',
  'publishProject',
  'redeploy',
];

const impl = {};

const call = (name) => (...args) => {
  const fn = impl[name];
  if (typeof fn !== 'function') {
    console.warn(`[DamyxWorkspaceAPI] ${name} no está disponible (Workspace cerrado)`);
    return null;
  }
  return fn(...args);
};

const surface = WORKSPACE_API_NAMES.reduce((acc, name) => {
  acc[name] = call(name);
  return acc;
}, {});

surface.isReady = () => WORKSPACE_API_NAMES.every((n) => typeof impl[n] === 'function');
surface.names = () => [...WORKSPACE_API_NAMES];

if (typeof window !== 'undefined') {
  window.DamyxWorkspaceAPI = surface;
}

/** El Workspace llama a esto con las implementaciones reales. */
export const registerWorkspaceApi = (fns = {}) => {
  Object.keys(fns).forEach((key) => {
    if (WORKSPACE_API_NAMES.includes(key) && typeof fns[key] === 'function') {
      impl[key] = fns[key];
    }
  });
};

export const unregisterWorkspaceApi = () => {
  WORKSPACE_API_NAMES.forEach((name) => { delete impl[name]; });
};

export default surface;
